import styled from 'styled-components';

export const Container = styled.div`
  border-top: solid 3px #185335;
  width: 100%;
  margin-top: 0.5rem;
  box-shadow: 0px 10px 60px 0px rgb(0 0 0 / 10%),
    0px 0px 0px 1px rgb(0 0 0 / 1%);

  .container-feedback {
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .actions {
    display: flex;
    align-items: flex-start;
    flex-direction: column;

    &__checkbox {
      display: flex;
      align-items: center;
    }

    @media screen and (min-width: 992px) {
      flex-direction: row;
      align-items: center;
    }

    &__buttons {
      display: flex;
      align-items: center;
      margin-left: 3px;
      margin-bottom: 15px;
      margin-top: 8px;

      @media screen and (min-width: 992px) {
        margin-left: 15px;
        margin-bottom: 0px;
        margin-top: 0px;
      }

      span {
        font-size: 0.875rem;
        display: inline-block;
        margin: 0 10px;
      }

      button {
        font-size: 0.875rem;
        padding: 3px 6px;
        border-radius: 4px;
        cursor: pointer;
        transition: all ease 0.3s;
        display: flex;
        align-items: center;
        background-color: rgb(24, 83, 53);
        border: solid 1px rgb(24, 83, 53);
        outline: none;
        color: #fff;
      }
    }
  }
`;
